let lastId: number = 0;

export default function (prefix: string = 'id-') {
  lastId++;
  return `${prefix}${lastId}`;
}
